/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCmsListContent Input Action
 */
export class GetPodcastDetailListTopArticleInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_PODCAST_TOP_ARTICLE`;
    public getCacheObjectType = () => 'CMS_PODCAST_TOP_ARTICLE';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetPodcastDetailListTopArticleData {
    dataTopArticle: AttributeValue[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetPodcastDetailListTopArticleInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(
    input: GetPodcastDetailListTopArticleInput,
    ctx: Msdyn365.IActionContext
): Promise<IGetPodcastDetailListTopArticleData | null> {
    const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
    const requestUrl = `${frontApiEndpoint}/api/list/podcast-detail/top-article`;
    const result = await Msdyn365.sendRequest<IGetPodcastDetailListTopArticleData>(requestUrl, 'get')
        .then(response => {
            return response.data;
        })
        .catch(error => {
            ctx.trace('[GetCmsPodcastDetailListTopArticle] Failed to get list podcast top article.');
            throw error;
        });
    return result;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetPodcastDetailListTopArticleData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsPodcastDetailListTopArticle',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
